module.exports = "/React/dist/19e60843546308090df840e0b81c411e.jpg";